import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './constants';

process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
